import request from '@/utils/request';
import { resolveMediaUrl } from '@/utils/resolve-media-url';

/** 从上传接口响应中解析文件 URL（相对路径会拼前置域名） */
export function resolveUploadFileUrl(payload) {
  if (!payload) return '';
  if (typeof payload === 'string') return resolveMediaUrl(payload.trim());

  const direct =
    payload.url ??
    payload.fileUrl ??
    payload.file_url ??
    payload.path ??
    payload.link ??
    payload.src;
  if (typeof direct === 'string' && direct.trim()) {
    return resolveMediaUrl(direct.trim());
  }

  if (payload.data !== undefined && payload.data !== null) {
    return resolveUploadFileUrl(payload.data);
  }

  return '';
}

/** 上传文件 POST /liyuan-file/upload（multipart/form-data，字段名 file） */
export function uploadFile(file) {
  const formData = new FormData();
  formData.append('file', file);
  return request.post('/liyuan-file/upload', formData);
}
